import { MetricsDetails, PzResponse } from './model/pz-response';
import { BffResponseObject, ErrorResponse } from './model/response';
import { PzAnalytics, Program } from 'models';
import HttpMethod from 'sources/http-methods';
import { ClientPzMetricAnalyticsRequest, PzCampaigns } from 'src/models/pz';

export class PartnerPerfSource {
  private availablePzProgramsNames: Array<keyof typeof PzCampaigns>;
  private availablePzPrograms: Program[];

  constructor(programs: Program[]) {
    const pzPrograms = programs.filter((program) => program.network === 'PARTNERIZE');
    this.availablePzPrograms = pzPrograms;
    this.availablePzProgramsNames = pzPrograms.map((program) => program.name as keyof typeof PzCampaigns);
  }

  public async getPzAnalytics(
    clientRequest: ClientPzMetricAnalyticsRequest,
  ): Promise<BffResponseObject<MetricsDetails[]>> {
    const pzMetricRequest: PzAnalytics = {
      ...clientRequest,
      programs: this.availablePzProgramsNames,
    };

    const response = await fetch('/api/v1/pz/analytics', {
      method: HttpMethod.POST,
      body: JSON.stringify(pzMetricRequest),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      } as HeadersInit,
    });

    const data: PzResponse = await response.json();

    if (data.success === true) {
      const overallMetrics = data.body.clicks.map((clickMetric) => {
        const targetedConversionMetric = data.body.conversions.find(
          (conversion) => conversion.campaign_id === clickMetric.campaign_id,
        );

        return {
          ...clickMetric,
          ...targetedConversionMetric,
        };
      });

      return {
        success: true,
        error: null,
        resBody: overallMetrics,
      };
    } else {
      return Promise.reject({
        message: data.errorCode,
        detail: {
          statusCode: data.body.code,
          statusMessage: data.body.message,
        },
      } as ErrorResponse<{ statusCode: string; statusMessage: string }>);
    }
  }

  public getAvailablePzPrograms(): Program[] {
    return this.availablePzPrograms;
  }
}
